var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"breadcrumbs"},[_c('router-link',{attrs:{"to":"/categories"}},[_vm._v("Categories")]),_c('span',{staticClass:"caret"},[_vm._v(">")]),_c('span',[_vm._v(_vm._s(_vm.categoryTitle))])],1),_c('product-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }